import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
//axios.defaults.baseURL = 'http://nkworks'
import VueScrollTo from 'vue-scrollto'
import titleMixin from './util/title'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueAnalytics from 'vue-analytics'

import './assets/css/style.css';

Vue.prototype.$axios = axios;
Vue.config.productionTip = false
Vue.mixin(titleMixin)

Vue.use(VueScrollTo, {
  container: "body",
  duration: 750,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAIDAq-PJcJBghbHEV2LNdmiXGrQTDW8r8',
    libraries: 'places'
  }
})

Vue.use(VueAnalytics, {
  id: 'UA-9343837-1',
  router
})

new Vue({
  router,
  watch: {
    '$route'() {
    }
  },
  render: h => h(App)
}).$mount('#app')
